export const excludedRoutes = [
  "Login",
  "Free Trial",
  "Page Not Found",
  "Select Dashboard",
  "Setting",
  "No Permission",
  "Subscription",
  "Confirm",
  "Accept Invitation",
  "Forget Password",
  "TrusteeLogin",
  "TestForm",
  "Otp",
  "Register",
  "Signup",
  "Delegate Access",
];
